const arrayIsSubset = (array1, array2) => {
  if ((!array1 || !array2) || !array2.length >= 1) {
    return false;
  }

  return array2.every((element) => array1.includes(element));
};

export default arrayIsSubset;
